import Reveal from "@/components/site/Reveal";

const PRINCIPLES = ["Every material.", "Every object.", "Every decision."];

export default function Philosophy() {
  return (
    <section
      id="philosophy"
      data-testid="philosophy-section"
      className="relative bg-[#F5F3EE] py-32 md:py-52"
    >
      <div className="max-w-[1500px] mx-auto px-6 md:px-14">
        <Reveal>
          <p className="text-[11px] uppercase tracking-[0.34em] text-[#9c7a4e] mb-16 md:mb-24">
            Philosophy
          </p>
        </Reveal>

        <h2 className="font-display font-light text-[#23221f] leading-[1.04] tracking-[-0.01em] text-4xl sm:text-6xl md:text-7xl lg:text-[5.4rem] max-w-5xl">
          <Reveal delay={0.02}>
            <span className="block">We believe great interiors</span>
          </Reveal>
          <Reveal delay={0.1}>
            <span className="block">aren&rsquo;t assembled.</span>
          </Reveal>
          <Reveal delay={0.18}>
            <span className="block italic text-[#9c7a4e]">They&rsquo;re curated.</span>
          </Reveal>
        </h2>

        <div className="mt-20 md:mt-28 border-t border-[#ded6c6] pt-10 grid grid-cols-1 sm:grid-cols-3 gap-8 max-w-4xl">
          {PRINCIPLES.map((p, i) => (
            <Reveal key={p} delay={0.1 + i * 0.1}>
              <p className="font-display text-2xl md:text-3xl font-light text-[#23221f]">{p}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
